import React, { useEffect } from "react";
import { bool, func, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { setToogleTheme } from "../../helper/actions";
import { getTheme } from "../../helper/localstorage";
import translate from "../../translate";

import "./toggle-theme.m.css";

const ToggleTheme = ({ isDarkTheme, setToogleTheme, publisherName }) => {
  // This useEffect is called only once to get the theme from localstorage
  useEffect(() => {
    setToogleTheme(getTheme(), true);
  }, []);

  /**
   * This useEffect will be called in 2 scenarios
   * 1. When user toggle's the theme
   * 2. When above useEffect updates the isDarkTheme in redux store
   */
  useEffect(() => {
    if (publisherName === "fit") {
      document.documentElement.setAttribute("theme", `fit-${isDarkTheme ? "dark" : "white"}`);
    } else {
      document.documentElement.setAttribute("theme", `quint-${isDarkTheme ? "dark" : "white"}`);
    }
  }, [isDarkTheme]);

  const onToggleThemeChange = (e) => setToogleTheme(e.target.checked);

  return (
    <div styleName="toggle-theme" className="toggle-theme">
      <label styleName="switch">
        <input type="checkbox" styleName="switch-input" checked={isDarkTheme} onChange={onToggleThemeChange} />
        <span styleName="slider" className="toggle-theme-slider" />
      </label>
      <span styleName="text" className="toggle-theme-text">
        {translate(publisherName, "dark_mode")}
      </span>
    </div>
  );
};

ToggleTheme.propTypes = {
  isDarkTheme: bool,
  setToogleTheme: func,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  isDarkTheme: get(state, ["settingsReducer", "isDarkTheme"], false),
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

const mapDispatchToProps = (dispatch) => ({
  setToogleTheme: (flag) => dispatch(setToogleTheme(flag)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ToggleTheme);
